<section class="skills" id="skills">
  <div class="titleskill reveal">
    <h2 class="titleskill colorw"><span>Our Expertise :</span><span>Innovation that Inspires Confidence</span></h2>
  </div>
  <div class="content">
    <!-- Colonne gauche : Texte résumé -->
    <div class="column col-left reveal">
      <h2 class="content-title">Foundations of Success: Data Science, Behavioral Psychology, and Creativity</h2>
      <p>
        Success is not just about tools; it’s about understanding people. With deep insights into human behavior and advanced data science techniques, we design solutions that resonate. Our strategies blend analytical precision with bold creativity, ensuring every step you take leads to measurable success
      </p>

      <div id="details" class="more-info reveal" style="display:none;">
        <p>
          Imagine knowing exactly what motivates your audience. Using advanced analytics and expert knowledge in sales psychology, we identify the emotional and logical triggers that transform prospects into loyal advocates.
        </p>
      </div>

      <button class="btn">Learn more</button>
    </div>

    <!-- Colonne droite : Compétences sous forme de grille -->
    <div class="column col-right reveal">
      <div class="skills-grid">
        <!-- Compétence 1: Développement Web -->
        <div class="skill-card">
          <div class="icon-container">
            <img src="/5.jpg" alt="marketing" />
          </div>
          <div class="skill-info">
            <h3>Marketing Strategy: Science Meets Persuasion</h3>
            <p>Imagine campaigns that not only reach but resonate. We harness data-driven insights and psychological expertise to craft marketing strategies that speak directly to your audience’s deepest motivations.</p>
          </div>
        </div>

        <!-- Compétence 2: Psychologie de la Vente -->
        <div class="skill-card">
          <div class="icon-container">
            <img src="/3.png" alt="Sales Psychology: Beyond Transactions" />
          </div>
          <div class="skill-info">
            <h3>Sales Psychology: Beyond Transactions</h3>
            <p>Empower your sales process with a deep understanding of what truly drives decisions. Connect, persuade, and build loyalty with every interaction.</p>
          </div>
        </div>
        <!-- Compétence 3: Data Science -->
        <div class="skill-card">
          <div class="icon-container">
            <img src="/6.jpg" alt="Data Science: From Numbers to Narratives" />
          </div>
          <div class="skill-info">
            <h3>Data Science: From Numbers to Narratives</h3>
            <p>Let data tell the story of your success. With precise, actionable insights, you’ll make strategic decisions with confidence and clarity.</p>
          </div>
        </div>

        <!-- Compétence 4: Design 3D -->
        <div class="skill-card">
          <div class="icon-container">
            <img src="/2.png" alt="3D Design: Immersive Impact" />
          </div>
          <div class="skill-info">
            <h3>3D Design: Immersive Impact</h3>
            <p>Your story deserves to be seen. Dazzle your clients with visuals that inspire and immerse, leaving an unforgettable impression.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="services" id="services">
  <div class="titleservice">
    <div class="first">
      <h2 class="titleservice">Our Services: Where Technology Meets Humanity</h2>
      <p>
        In a world of constant change, growth requires bold, innovative tools. At Cognitiex, we empower you to innovate, thrive, and outpace the competition.
      </p>
    </div>
  </div>

  <div class="content">
    <div class="card reveal">
      <div class="service-icon">
      </div>
      <div class="info">
        <h3>Scalable Platform: Your Growth, Amplified</h3>
        <p>
          Our platform adapts to your evolving needs, unlocking performance gains and uncovering untapped opportunities.
        </p>
      </div>
    </div>
    <div class="card reveal">
      <div class="service-icon">
      </div>
      <div class="info">
        <h3>Psychological Assistance: Emotion Meets Strategy</h3>
        <p>
          Move beyond selling. Build trust, spark emotional connections, and foster lasting relationships with your customers.
        </p>
      </div>
    </div>
    <div class="card reveal">
      <div class="service-icon">
      </div>
      <div class="info">
        <h3>Artificial Intelligence: Smarter, Faster, Better</h3>
        <p>
          Leverage AI to anticipate trends, optimize processes, and execute flawlessly at every stage of your strategy.
        </p>
      </div>
    </div>
  </div>
</section>
